import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switches',
  templateUrl: './switches.component.html',
  styleUrls: ['./switches.component.scss']
})
export class SwitchesComponent implements OnInit {

  @Input() switchType;
  constructor() { }

  ngOnInit() {
  }

  @Output() selectionChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  onSelectionChange(event): void {
    //debugger
    console.log(event)
    if (event !== undefined && event !== null) {
      this.selectionChanged.emit(event);
    }
  }
}
